import { formatNumber } from '@ztechapps/common.utils'

export const ProgressTooltip = ({ now, max }: { now: number; max: number }) => {
  const percentage = max > 0 ? now / max : 0
  const percentageString = formatNumber(percentage, '0%')
  return (
    <>
      Progress: {now} out of {max} <br />
      Percetage: <b>{percentageString}</b>
    </>
  )
}
